import React, { useState } from "react";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await fetch("https://localhost:44351/api/home/contactMessage", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });
  
      const responseData = await response.json();
      
      if (response.ok) {
        setSubmitted(true);
        setError(""); 
      } else {
        throw new Error(responseData.message || "Something went wrong while sending your message.");
      }
    } catch (error) {
      setError(error.message);
      console.error("Error:", error);
    }
  };

  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "40px auto",
        padding: "30px",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <h1 style={{ textAlign: "center", color: "#333" }}>Contact Us</h1>
      <p style={{ textAlign: "center", color: "#555", fontSize: "1.1rem" }}>
        We would love to hear from you! If you have questions, suggestions, or news tips,
        feel free to contact us.
      </p>

      <div style={{ marginTop: "30px" }}>
        {submitted ? (
          <p style={{ color: "green", textAlign: "center", fontSize: "1.2rem" }}>
            Thank you! Your message has been sent.
          </p>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "20px" }}>
              <label
                htmlFor="name"
                style={{ display: "block", fontSize: "1rem", marginBottom: "8px", fontWeight: "500" }}
              >
                Name:
              </label>
              <input
                type="text"
                name="name"
                id="name"
                value={form.name}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "1rem",
                }}
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                htmlFor="email"
                style={{ display: "block", fontSize: "1rem", marginBottom: "8px", fontWeight: "500" }}
              >
                Email:
              </label>
              <input
                type="email"
                name="email"
                id="email"
                value={form.email}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "1rem",
                }}
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                htmlFor="message"
                style={{ display: "block", fontSize: "1rem", marginBottom: "8px", fontWeight: "500" }}
              >
                Message:
              </label>
              <textarea
                name="message"
                id="message"
                value={form.message}
                onChange={handleChange}
                required
                rows="6"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "1rem",
                  resize: "vertical",
                }}
              />
            </div>

            {error && (
              <div style={{ color: "crimson", textAlign: "center", marginBottom: "20px" }}>
                <p>{error}</p>
              </div>
            )}

            <div style={{ color: "crimson", textAlign: "center" }}>
              <button
                type="submit"
                style={{
                  padding: "12px 30px",
                  fontSize: "1.1rem",
                  borderRadius: "5px",
                  backgroundColor: "crimson",  // Set background color to crimson
                  color: "white",  // Text color remains white for contrast
                  border: "none",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = "#D40000"} // Darker shade of crimson on hover
                onMouseOut={(e) => e.target.style.backgroundColor = "crimson"}  // Reverts to crimson on mouse out
              >
                Send Message
              </button>
            </div>
          </form>
        )}
      </div>

      <hr style={{ margin: "40px 0" }} />

      <h3 style={{ textAlign: "center", color: "#333" }}>Contact Information</h3>
      <p style={{ textAlign: "center", fontSize: "1.1rem" }}>
        <strong>Email:</strong> contact@yournewswebsite.com
      </p>
      <p style={{ textAlign: "center", fontSize: "1.1rem" }}>
        <strong>Phone:</strong> +1 234 567 890
      </p>
      <p style={{ textAlign: "center", fontSize: "1.1rem" }}>
        <strong>Address:</strong> 123 News Avenue, City, Country
      </p>
    </div>
  );
};

export default Contact;
